function setBandeauMobileHeight() {
	const bandeauMobile = document.querySelector('.bandeau-mobile');
	if (bandeauMobile) {
		const height = bandeauMobile.offsetHeight;
		document.documentElement.style.setProperty('--bandeau-mobile-height', `${height}px`);
	} else {
		document.documentElement.style.setProperty('--bandeau-mobile-height', '0px');
	}
}

function setBlogHeroMargin() {
	const header = document.querySelector('.cdv-header');
	const blogHeroes = document.querySelectorAll('.cdv-home-blog-hero, .cdv-blog-hero');
	if (!header || !blogHeroes.length) return;
	const marginTop = header.offsetHeight;
	blogHeroes.forEach((el) => {
		el.style.setProperty('margin-top', `${marginTop}px`, 'important');
	});
}

function onScrollTogglePinned(header) {
	header.classList.toggle('cdv-header--pinned', window.scrollY === 0);
}

function onScrollToggleHero(header, heroHeight) {
	header.classList.toggle('cdv-header--hero', window.scrollY > heroHeight);
}

function onScrollToggle(header, heroThreshold) {
	onScrollTogglePinned(header);
	onScrollToggleHero(header, heroThreshold);
}

function isBlogPage() {
	return window.location.pathname.includes('/blog/');
}

function initHeadroom() {
	try {
		const header = document.querySelector('.cdv-header');
		if (!header) return;

		const hero = document.querySelector('.cdv-hero, .cdv-main-hero, .cdv-hero-inner');
		const headerHolder = document.querySelector('.cdv-header__holder');
		const headerHolderHeight = headerHolder ? headerHolder.offsetHeight : 0;

		if (hero) {
			const heroHeight = hero.offsetHeight;
			onScrollToggle(header, heroHeight - headerHolderHeight);
			window.addEventListener('scroll', () => onScrollToggle(header, heroHeight - headerHolderHeight));
		} else if (isBlogPage()) {
			// Sur le blog (home + articles), utiliser le hero blog comme seuil, sans état pinned
			const blogHero = document.querySelector('.cdv-home-blog-hero, .cdv-blog-hero');
			if (blogHero) {
				const blogHeroHeight = blogHero.offsetHeight;
				const heroThreshold = blogHeroHeight - headerHolderHeight;
				header.classList.remove('cdv-header--pinned');
				onScrollToggleHero(header, heroThreshold);
				window.addEventListener('scroll', () => {
					header.classList.remove('cdv-header--pinned');
					onScrollToggleHero(header, heroThreshold);
				});
			}
		}

		// Set the height of the bandeau mobile
		setBandeauMobileHeight();

		// Margin du hero sur les pages blog (exécuté même sans hero, ex. page listing blog)
		if (isBlogPage()) {
			setBlogHeroMargin();
			window.addEventListener('resize', setBlogHeroMargin);
		}

		// Réajuster le bandeau mobile au resize
		window.addEventListener('resize', setBandeauMobileHeight);
	} catch (_err) {
		
	}
}

function adjustTourBoxPosition(isHeaderHidden) {
	const tourBox = document.querySelector('.tour-box');
	if (!tourBox) return;

	// Vérifier si on est sur desktop (breakpoint à 1030px selon _variables.scss)
	const isDesktop = window.matchMedia('(min-width: 1030px)').matches;
	if (!isDesktop) {
		// Réinitialiser le style si on n'est plus sur desktop
		tourBox.style.top = '';
		return;
	}

	const header = document.querySelector('.cdv-header');
	if (!header) return;

	// Calculer la hauteur réelle du header
	const headerHeight = header.offsetHeight;
	
	// Valeur de base du top (184px selon le SCSS)
	const baseTop = 184;
	
	// Si le header est caché, soustraire sa hauteur
	const newTop = isHeaderHidden ? baseTop - headerHeight + 40 : baseTop;
	
	tourBox.style.top = `${newTop}px`;
}

function handleHeaderVisibility(header, state) {
	const currentScrollY = window.scrollY;
	const scrollDifference = currentScrollY - state.lastScrollY;

	if(window.flagQcdScrolling) return;

	const wasHeaderHidden = state.isHeaderHidden;

	// Si on a scrollé d'au moins une hauteur d'écran vers le bas
	if (currentScrollY >= state.scrollThreshold && scrollDifference > 0 && !state.isHeaderHidden) {
		header.classList.add(state.hideHeaderClass);
		state.isHeaderHidden = true;
	}
	// Si on scroll vers le haut (même un peu), réafficher le header
	else if (scrollDifference < 0 && state.isHeaderHidden) {
		header.classList.remove(state.hideHeaderClass);
		state.isHeaderHidden = false;
	}
	// Si on revient en haut de la page, s'assurer que le header est visible
	else if (currentScrollY < state.scrollThreshold && state.isHeaderHidden) {
		header.classList.remove(state.hideHeaderClass);
		state.isHeaderHidden = false;
	}

	// Ajuster la position du tour-box si l'état du header a changé
	if (wasHeaderHidden !== state.isHeaderHidden) {
		adjustTourBoxPosition(state.isHeaderHidden);
	}

	state.lastScrollY = currentScrollY;
}

function initHeaderVisibility() {
	const header = document.querySelector('.cdv-header');
	if (!header) return;

	// Variables pour la logique de masquage/affichage du header
	const state = {
		lastScrollY: window.scrollY,
		scrollThreshold: window.innerHeight, // Une taille d'écran
		hideHeaderClass: 'cdv-header--hidden',
		isHeaderHidden: false
	};

	// Initialiser la position du tour-box
	adjustTourBoxPosition(state.isHeaderHidden);

	// Écouter les changements de taille de fenêtre pour réajuster si nécessaire
	let resizeTimeout = null;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			adjustTourBoxPosition(state.isHeaderHidden);
		}, 100);
	});

	// Utiliser requestAnimationFrame pour optimiser les performances
	let ticking = false;
	window.addEventListener('scroll', () => {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				handleHeaderVisibility(header, state);
				ticking = false;
			});
			ticking = true;
		}
	});
}

export { 
	initHeaderVisibility, 
	initHeadroom 
};
